module.exports = __webpack_public_path__ + "img/portrait-dazed1.598f034f.svg";